module.exports = __webpack_public_path__ + "assets/img/binding-2.39f1dab8.jpg";